import { Component, Inject } from '@angular/core';
import { Package } from '@vendasta/marketplace-packages';
import { BehaviorSubject, Observable, combineLatest, firstValueFrom } from 'rxjs';
import { PipelineFilterPackageStoreService } from './pipeline-filter-package-store.service';
import { MatDialog } from '@angular/material/dialog';
import { PipelineFilterPackageSelectionService } from './pipeline-filter-package-selection.service';
import { map, take } from 'rxjs/operators';
import { SelectedDropdownItem } from '@galaxy/inventory-ui';
import { ItemType, ListActivatableItemsFilters } from '@vendasta/marketplace-apps';
import { MARKET_ID_TOKEN, PARTNER_ID_TOKEN } from './tokens';

@Component({
  templateUrl: './pipeline-filter-package-selector.html',
  styleUrls: ['./pipeline-filter-package-selector.scss'],
})
export class PipelineFilterPackageSelectorComponent {
  packages$: Observable<Package[]>;
  selectedItems: SelectedDropdownItem[] = [];
  savingFilter$$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  savingFilter$: Observable<boolean> = this.savingFilter$$.asObservable();
  itemSelectorFilters = new ListActivatableItemsFilters({
    itemTypes: [ItemType.ITEM_TYPE_PACKAGE],
  });
  readonly userData$ = combineLatest([this.partnerId$, this.marketId$]).pipe(
    map(([partnerId, marketId]) => {
      return {
        partnerId: partnerId,
        marketId: marketId,
      };
    }),
  );

  constructor(
    @Inject(PARTNER_ID_TOKEN) readonly partnerId$: Observable<string>,
    @Inject(MARKET_ID_TOKEN) readonly marketId$: Observable<string>,
    private readonly pkgStore: PipelineFilterPackageStoreService,
    private readonly pkgSelection: PipelineFilterPackageSelectionService,
    private readonly dialog: MatDialog,
  ) {
    this.packages$ = this.pkgStore.packages$;

    this.pkgSelection.selectedPackages$.pipe(take(1)).subscribe((checkedPkgs) => {
      this.selectedItems = checkedPkgs.map((p) => ({ appId: p.packageId, name: p.name }));
    });
  }

  async handlePackageSelection(): Promise<void> {
    this.savingFilter$$.next(true);
    const packages = await firstValueFrom(this.packages$);
    const selectedPackages = packages.filter((p) => this.selectedItems.some((i) => i.appId === p.packageId));
    this.pkgSelection.setPackageSelection(selectedPackages);
    this.savingFilter$$.next(false);
    this.dialog.closeAll();
  }

  onSelectionChange(newSelection: SelectedDropdownItem[]): void {
    this.selectedItems = newSelection;
  }
}
